import React, { useState } from 'react';
import { useProgress } from '../context/ProgressContext';
import { DayCard } from '../components';
import { lessons, getLessonsBySaptamana } from '../data/lessons';
import './PlanPage.css';

export const PlanPage: React.FC = () => {
  const { progress } = useProgress();
  const [selectedWeek, setSelectedWeek] = useState<number | null>(null);

  const weeks = [1, 2, 3, 4, 5, 6];
  
  const weekTitles: Record<number, string> = {
    1: 'Setup + Structură + Progres',
    2: 'CSS + Grid + Accesibilitate',
    3: 'Logică + Filtre + Teste',
    4: 'Mini-Joc Canvas',
    5: 'AI Generator + Securizare',
    6: 'Export/Import + Deploy + Demo',
  };

  const getWeekProgress = (week: number) => {
    const weekLessons = getLessonsBySaptamana(week);
    const completed = weekLessons.filter((l) =>
      progress.lessonsCompleted.includes(l.id)
    ).length;
    return { completed, total: weekLessons.length };
  };

  const getCurrentLesson = () => {
    const completed = progress.lessonsCompleted;
    for (const lesson of lessons) {
      if (!completed.includes(lesson.id)) {
        return lesson.id;
      }
    }
    return lessons.length + 1;
  };

  const currentLessonId = getCurrentLesson();

  const filteredLessons = selectedWeek
    ? getLessonsBySaptamana(selectedWeek)
    : lessons;

  return (
    <div className="plan-page">
      <header className="plan-header">
        <h1>Plan 30 de Zile</h1>
        <p className="plan-subtitle">
          În fiecare zi, 30 de minute. La final, un joc și o colecție de trofee.
        </p>
      </header>

      <div className="week-tabs">
        <button
          className={`week-tab ${selectedWeek === null ? 'active' : ''}`}
          onClick={() => setSelectedWeek(null)}
          type="button"
        >
          Toate
        </button>
        {weeks.map((week) => {
          const { completed, total } = getWeekProgress(week);
          const isComplete = completed === total;
          return (
            <button
              key={week}
              className={`week-tab ${selectedWeek === week ? 'active' : ''} ${isComplete ? 'complete' : ''}`}
              onClick={() => setSelectedWeek(week)}
              type="button"
            >
              <span className="week-tab-name">S{week}</span>
              <span className="week-tab-progress">
                {completed}/{total}
              </span>
            </button>
          );
        })}
      </div>

      {selectedWeek && (
        <div className="week-info">
          <h2>Săptămâna {selectedWeek}</h2>
          <p>{weekTitles[selectedWeek]}</p>
        </div>
      )}

      <div className="lessons-grid">
        {filteredLessons.map((lesson) => {
          const isCompleted = progress.lessonsCompleted.includes(lesson.id);
          const isCurrent = lesson.id === currentLessonId;
          const isLocked = lesson.id > currentLessonId;

          return (
            <DayCard
              key={lesson.id}
              lesson={lesson}
              isCompleted={isCompleted}
              isCurrent={isCurrent}
              isLocked={isLocked}
            />
          );
        })}
      </div>

      <section className="legend-section">
        <h3>Legendă</h3>
        <div className="legend-items">
          <div className="legend-item">
            <span className="legend-indicator current"></span>
            <span>Lecția curentă</span>
          </div>
          <div className="legend-item">
            <span className="legend-indicator completed"></span>
            <span>Completată</span>
          </div>
          <div className="legend-item">
            <span className="legend-indicator locked"></span>
            <span>Blocată</span>
          </div>
        </div>
      </section>
    </div>
  );
};
